import axios from 'axios';
import { BOX_CONFIG, BOX_API, /*SUPPORT_FILE_MIME_TYPES, getFileNameWithExtension,*/ SUPPORT_FILE_EXTENSIONS, setDriveTokenInfo, BOX } from './drives.constants';
import { baseUrlApis } from 'Api/index';
import { URL_PLATFORM } from 'Api/constants';
import { store } from 'Store/index';
import { convertUTCToLocale, getFileSize, handlerFileNameWithoutExtension, storageGetItem, storageRemoveItem, storageSetItem, windowActionFn } from 'Utils/utils';
import intl from 'react-intl-universal';

export default class BoxApi {
  constructor() {
    this.downloadFileRequest = false;
    this.uploadFileRequest = false;
    this.updateFileRequest = false;
    this.cancelDownloadFileFn = null;
    this.cancelUploadFileFn = null;
    this.cancelUpdateFileFn = null;
    this.boxAxios = null;
    this.CancelToken = axios.CancelToken;
    this.platformBaseURL = null;

    this.init();
  }
  async init() {
    let result = '';

    try {
      result = await baseUrlApis.getBaseUrlBy(URL_PLATFORM);

      this.platformBaseURL = `${result}/platform`;
    } catch (error) {
      console.error('getBaseUrl failed');
    }

    this.boxAxios = axios.create({
      baseURL: BOX_API.BASEURL,
    });
    this.boxAxios.interceptors.request.use(
      (config) => {
        store.driveStore.numberOfAjaxCAllPendingIncrease();

        let accessToken = storageGetItem(localStorage, 'BoxAccessToken');

        if (accessToken) {
          config.headers = {
            Authorization: `Bearer ${accessToken}`,
            ...config.headers,
          };
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    this.boxAxios.interceptors.response.use(
      (res) => {
        store.driveStore.numberOfAjaxCAllPendingDecrease();

        return res.data;
      },
      (error) => {
        store.driveStore.numberOfAjaxCAllPendingDecrease();

        if (error.response && error.response.data && error.response.data.message === "Item with the same name already exists") {
          return 'name exist'
        }

        if (error.message === 'Network Error') {
          let errorMsg = intl.formatMessage({ id: 'NetworkError' });

          store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
        }

        this.errorHandler(error);

        if (error.autoSignOut) {
          storageRemoveItem(localStorage, 'BoxAccessToken');
        }

        return Promise.reject(error);
      },
    );
  }
  errorHandler(error) {
    let errorMsg;
    // let autoSignOut = false;
    let status = error.status || (error.response && error.response.status);

    if (error.__CANCEL__) {
      errorMsg = intl.formatMessage({ id: 'CancelRequest' });
    } else if (status === 401) {
      // autoSignOut = true;
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'InvalidToken' });
    } else if (status === 404) {
      errorMsg = intl.formatMessage({ id: 'FileNotExist' });
    } else {
      // autoSignOut = true;
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'Error.SignOutAndRetry' });
    }

    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }
  getAccessToken(code, success, fail) {
    let fd = new FormData();

    fd.append('code', code);
    fd.append('grant_type', 'authorization_code');
    fd.append('client_id', BOX_CONFIG.CLIENT_ID);
    fd.append('client_secret', BOX_CONFIG.CLIENT_SECRET);

    this.boxAxios({
      url: BOX_API.GET_ACCESS_TOKEN,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: fd,
    })
      .then((res) => {
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  getItems(folderId, success, fail) {
    let url;

    if (folderId) {
      url = `${BOX_API.GET_FILES}/${folderId}/items`;
    } else {
      url = BOX_API.GET_ROOT_FILES;
    }

    this.boxAxios({
      url,
      method: 'GET',
      params: {
        fields: 'created_at,name,size,modified_at',
      },
    })
      .then((res) => {
        let folders = [];
        let files = [];

        res.entries.forEach((item) => {

          if (item.type === 'folder') {
            // item.size = `${(item.size / 1024 / 1024).toFixed(2)}MB`;
            item.size = '';
            item.modifiedTime = '';
            item.isFolder = true;
            folders.push(item);
          }
          if (item.type === 'file' && SUPPORT_FILE_EXTENSIONS.indexOf(item.name.replace(/.+\./,""))  > -1) {
            item.originSize = item.size
            item.size = getFileSize(item.size);
            item.modifiedTime = convertUTCToLocale(item.modified_at);
            files.push(item);
          }
        });

        const { saveType } = store.driveStore

        if (saveType) {
          files = files.filter((item) => {
            const fileName = item.name
            const fileType = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

            return fileType === saveType
          })
        }

        res.result = {};
        res.result.files = [...folders, ...files];

        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  getUserInfo(success, fail) {
    this.boxAxios({
      url: BOX_API.GET_USER_INFO,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      fields: 'login, type',
    })
      .then((res) => {
        let accessToken = storageGetItem(localStorage, 'BoxAccessToken');

        res.userAccount = res.login
        res.accessToken = accessToken
        setDriveTokenInfo(BOX, res.userAccount)
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  signIn(success, closeWin, fail) {
    let left = window.innerWidth / 2 - 300;
    let _hTime = null;
    let _hWin = windowActionFn(window, 'open', [BOX_CONFIG.AUTHORIZATION_URL(), 'BoxAuthorizationWin', `width=600,height=645,left=${left}, top=240`])
    let _this = this;

    function onSignSuccess(token) {
      storageSetItem(localStorage, 'BoxAccessToken', token);
      success && success();
    }
    function onHandleWindowMessage(event) {
      // let origin = baseUrlApis.getBaseUrl();

      if (event.data.boxCode) {
        _this.getAccessToken(event.data.boxCode, (res) => {
          onSignSuccess(res.access_token);
          clean();
        },
        (error) => {
          fail && fail(error)
        });
      }
    }
    function onHandleStorage(e) {
      if (e.key === 'boxCode') {
        onSignSuccess(e.newValue);
        clean();
      }
    }
    function clean() {
      if (!_hWin) {
        return;
      }
      _hWin.close();
      _hWin = null;
      closeWin && closeWin()
      _hTime && clearInterval(_hTime);
      _hTime = null;
      window.removeEventListener('message', onHandleWindowMessage);
      window.removeEventListener('storage', onHandleStorage);
    }
    _hTime = setInterval(() => {
      if (_hWin.closed) {
        clean();
      }
    }, 2000);

    window.addEventListener('message', onHandleWindowMessage, false);
    window.addEventListener('storage', onHandleStorage, false);
  }
  signOut(success, /* fail */) {
    storageRemoveItem(localStorage, 'BoxAccessToken');
    success && success();
  }
  downloadFile(item, success, fail) {
    this.downloadFileRequest = true;
    this.boxAxios({
      url: `${BOX_API.DOWNLOAD_FILE}/${item.id}/content`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      cancelToken: new this.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        this.cancelDownloadFileFn = c;
      }),
    })
      .then((data) => {
        this.downloadFileRequest = false;

        success && success({ blob: data, id: item.id, fileName: item.name });
        // var file = new Blob([data], { type: data.type });

        // // 将二进制数据流转成URL对象
        // const url = window.URL.createObjectURL(file);
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', 'test.jpg'); // 需要指定文件格式。
        // document.body.appendChild(link);
        // link.click(); //点击事件
      })
      .catch((error) => {
        this.downloadFileRequest = false;

        fail && fail(error);
      });
  }
  cancelDownloadFile() {
    this.cancelDownloadFileFn && this.cancelDownloadFileFn();
  }
  createFolder({folderName, folderPath}) {
    const id = folderPath.length > 1 ? folderPath[folderPath.length - 1].id : '0';
    const data = JSON.stringify({
      name: folderName,
      parent: {
          id,
      }
    })

    return this.boxAxios({
      baseURL: BOX_API.BASEURL,
      url: BOX_API.CREATE_FOLDER,
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST",
      data,
    })
  }
  createFile(file, folderPath, success, fail) {
    let fd = new FormData();
    const access_token = store.userStore.token;
    const box_access_token =  storageGetItem(localStorage, 'BoxAccessToken');
    const fileName = handlerFileNameWithoutExtension(file.name);
    const folderId = folderPath.length > 1 ? folderPath[folderPath.length - 1].id : '0';

    fd.append('file', file);

    this.uploadFileRequest = true;
    this.boxAxios({
      baseURL: this.platformBaseURL,
      url: BOX_API.UPLOAD_FILE,
      method: 'POST',
      params: {
        access_token,
        box_access_token,
        fileName,
        folderId,
      },
      data: fd,
      cancelToken: new this.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        this.cancelUploadFileFn = c;
      }),
    })
      .then(() => {
        this.uploadFileRequest = false;

        success && success();
      })
      .catch((error) => {
        this.uploadFileRequest = false;

        fail && fail(error);
      });
  }
  cancelUploadFile() {
    this.cancelUploadFileFn && this.cancelUploadFileFn();
  }
  updateFile(fileId, file, success, fail, /* progress */) {
    let fd = new FormData();
    const access_token = store.userStore.token;
    const box_access_token =  storageGetItem(localStorage, 'BoxAccessToken');

    fd.append('file', file);

    this.updateFileRequest = true;
    this.boxAxios({
      baseURL: this.platformBaseURL,
      method: 'POST',
      url: BOX_API.UPDATE_FILE,
      params: {
        access_token,
        box_access_token,
        fileId,
      },
      data: fd,
      cancelToken: new this.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        this.cancelUpdateFileFn = c;
      }),
    })
      .then(() => {
        this.updateFileRequest = false;

        success && success();
      })
      .catch((error) => {
        this.updateFileRequest = false;

        fail && fail(error);
      });
  }
  cancelUpdatedFile() {
    this.cancelUpdateFileFn && this.cancelUpdateFileFn();
  }
  isSignIn() {
    let accessToken = storageGetItem(localStorage, 'BoxAccessToken');

    if (accessToken) {
      return true;
    } else {
      return false;
    }
  }
  // createFolder() {
  //   this.boxAxios({
  //     baseURL: BOX_API.UPLOAD_BASEURL,
  //     url: 'https://api.box.com/2.0/folders',
  //     method: 'POST',
  //     data: {
  //       name: 'test',
  //       parent: {
  //         id: 0,
  //       },
  //     },
  //   });
  // }
}
